import { DeleteOutlined, PlayCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button, Image, Modal,
  Progress, Upload
} from 'antd';
import { useState } from 'react';
import HtmlVideolayer from '@components/video/player/html-player';
import style from './list-media.module.scss';

interface IProps {
  remove: Function;
  files: any[];
  onAddMore: Function;
  uploading: boolean;
  type: string;
}

export function UploadList({
  remove, files, onAddMore, uploading, type
}: IProps) {
  const [isShowPreview, setIsShowPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  return (
    <div className={style['f-upload-list']}>
      {files && files.map((file) => (
        <div className={style['f-upload-item']} key={file._id || file.uid}>
          <div className={style['f-upload-thumb']}>
            {file.type.includes('video') ? (
              <div
                style={{ backgroundImage: `url(${file?.thumbnail || (file?.thumbnails && file?.thumbnails[0]) || '/leaf.jpg'})` }}
                className={style['f-thumb-vid']}
                aria-hidden
                onClick={() => {
                  if (!file?.url) return;
                  setIsShowPreview(true);
                  setPreviewUrl(file?.url);
                }}
              >
                <PlayCircleOutlined />
              </div>
            ) : <Image fallback="/heic-warning.webp" alt="img" src={file?.url} width="100%" />}
          </div>
          {file.status !== 'uploading'
            && (
              <Button type="primary" className={style['f-remove']} onClick={() => remove(file)}>
                <DeleteOutlined />
              </Button>
            )}
          {file.percent && <Progress percent={Math.round(file.percent)} />}
        </div>
      ))}
      {(type === 'photo' || (type === 'video' && !files.length)) && (
        <div className={style['add-more']}>
          <Upload
            customRequest={() => false}
            accept={type === 'video' ? 'video/*' : 'image/*,.heic,.heif'}
            beforeUpload={onAddMore.bind(this)}
            multiple={type === 'photo'}
            showUploadList={false}
            disabled={uploading}
            listType="picture"
          >
            <PlusOutlined />
            {' '}
            Add
            {' '}
            {/* eslint-disable-next-line no-nested-ternary */}
            {type === 'photo' ? 'photos' : type === 'video' ? 'video' : 'files'}
          </Upload>
        </div>
      )}
      {isShowPreview && (
        <Modal
          width={767}
          footer={null}
          onOk={() => setIsShowPreview(false)}
          onCancel={() => setIsShowPreview(false)}
          open={isShowPreview}
          destroyOnClose
        >
          <HtmlVideolayer
            videoSrc={previewUrl}
            videoId=""
            thumbUrl={null}
          />
        </Modal>
      )}
    </div>
  );
}

export default UploadList;
